module.exports = __webpack_public_path__ + "img/bg.350afee7.png";